const isSlotElement = el => {
  return el.tagName === 'SLOT';
};
export const getFirstSlotElement = function (root) {
  let isDeep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const el = root.assignedElements()[0];
  if (el == null) {
    return null;
  }
  if (isDeep && isSlotElement(el)) {
    return getFirstSlotElement(el, isDeep);
  }
  return el;
};
const getChildren = root => {
  if (isSlotElement(root)) {
    return root.assignedElements();
  }
  return Array.from(root.children);
};
const isFocusable = el => {
  return el.focusable === true;
};
export const getFirstFocusableElement = root => {
  for (const child of getChildren(root)) {
    if (isFocusable(child)) {
      return child;
    }
    const resultEl = getFirstFocusableElement(child);
    if (resultEl !== null) {
      return resultEl;
    }
  }
  return null;
};
export const isElementFocused = $el => {
  return $el !== null && $el === $el.getRootNode().activeElement;
};